// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"4504f41b","559":"dec24328"}[chunkId] + ".chunk.css";
};